import React,{useRef,useState} from 'react';
import API from '../api';

const message=error=>error?.response?.data?.message||error?.response?.data?.error||error?.message||'The location could not be recorded. Try again.';

export default function CampaignGeographyPanel({campaign,api=API}){
 const [context,setContext]=useState(null),[open,setOpen]=useState(false),[busy,setBusy]=useState(false),[error,setError]=useState(''),[saved,setSaved]=useState(false);
 const pending=useRef(null),base='/v1/veridian/campaigns/'+encodeURIComponent(campaign.campaign_id)+'/geography';
 async function load(){const result=await api.get(base);setContext(result.data);}
 async function show(){setOpen(true);setError('');setBusy(true);try{await load();}catch(error){setError(message(error));}finally{setBusy(false);}}
 async function initialize(){
  setError('');setBusy(true);
  try{
   if(!pending.current)pending.current={action_key:window.crypto.randomUUID(),expected_account_version:context.account_version,
    expected_campaign_version:context.campaign_version,settlement_definition_ref:context.settlement_definition.definition_ref,
    expected_settlement_definition_version:context.settlement_definition.definition_version};
   await api.post(base,pending.current);pending.current=null;setSaved(true);
   await load().catch(()=>setError('Your starter location was recorded. Reload this page to refresh it.'));
  }catch(error){setError(message(error));if(error.response?.status>=400&&error.response?.status<500){pending.current=null;await load().catch(()=>{});}}
  finally{setBusy(false);}
 }
 return <div className="vd-calendar" role="group" aria-label={'Location for '+campaign.name}>
  <button type="button" disabled={busy} onClick={show}>Location for {campaign.name}</button>
  {open&&<><h4>Starter location</h4>
   {error&&<p role="alert">{error}</p>}
   {saved&&<p role="status">Starter region and settlement site recorded. World time has not advanced.</p>}
   {context?.geography&&<p>{context.geography.site_name} · {context.geography.region_name}</p>}
   {context&&!context.geography&&!saved&&context.status==='DRAFT'&&<>
    {context.settlement_definition?<><p>Record {context.settlement_definition.name} and its local region for world setup. Routes and services will be added through their own setup.</p>
     <button type="button" disabled={busy} onClick={initialize}>{busy?'Recording location…':'Record starter location'}</button></>:
     <p>Save a settlement blueprint first, then reopen location setup.</p>}
   </>}
   <button type="button" disabled={busy} onClick={()=>setOpen(false)}>Close location</button>
  </>}
 </div>;
}
